module.exports = __webpack_public_path__ + "img/img_20@2x.57266cb3.png";